import { useMutation } from "@tanstack/react-query";
import { videoDelete } from "common/api/unos_rad/unos_video";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseUnosVideoDeleteParams = {
  invalidateKeys?: string[];
};

export const useUnosVideoDelete = (hookParams?: UseUnosVideoDeleteParams) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: videoDeleteMutate } = useMutation({
    mutationFn: async (id: string) => await videoDelete(id),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
    },
  });

  return { videoDeleteMutate };
};
